import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
} from '@angular/router';

import { AuthService } from '../security';

@Injectable({ providedIn: 'root' })
export class EditNephroMedicalInfosGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate() {
        return (
            this.authService.canEditMedicalInfos.nephro ||
            this.authService.isAdminAccounting
        );
    }
}
